import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DoctorDataModel} from '../../../../models/doctors/doctor-data.model';
import {MatSort} from '@angular/material/sort';
import {ClientLocationDataModel} from '../../../../models/clients/client-location-data.model';
import {FeeDiscountsService} from './fee-discounts-service';
import {TdoClientConfigurationModel} from '../../../../models/clients/tdo-client-configuration.model';
import {MatSelectChange} from '@angular/material/select';
import {CfgARFeeDiscountModel} from '../../../../models/accountsReceivable/cfg-ar-fee-discount.model';
import {EnumFeeDiscountCalcTypeEnum} from '../../../../models/enum/enum-fee-discount-calc-type.enum';
import {DoctorsService} from '../../../../services/doctors.service';
import {ConfigurationService} from '../../configuration.service';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';

@Component({
  selector: 'app-fee-discounts',
  templateUrl: './fee-discounts.component.html',
  styleUrls: ['./fee-discounts.component.scss']
})

export class FeeDiscountsComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;

  // Doctor
  doctorList: DoctorDataModel[];
  selectedDoctor: DoctorDataModel;

  // Client
  selectedClient: TdoClientConfigurationModel;
  clientList: TdoClientConfigurationModel[];

  // Location
  selectedLocation: ClientLocationDataModel;
  locationList: ClientLocationDataModel[];

  // Discounts
  discountList: CfgARFeeDiscountModel[];
  selectedDiscounts: CfgARFeeDiscountModel[];

  // current vars
  currentDoctorName: string;
  currentAmount1: number;
  currentPercent1: number;
  currentPercentChecked1: boolean;
  currentAmount2: number;
  currentPercent2: number;
  currentPercentChecked2: boolean;
  currentAmount3: number;
  currentPercent3: number;
  currentPercentChecked3: boolean;

  // backup vars
  currentAmount1DataBackup: number;
  currentPercent1DataBackup: number;
  currentPercentChecked1DataBackup: boolean;
  currentAmount2DataBackup: number;
  currentPercent2DataBackup: number;
  currentPercentChecked2DataBackup: boolean;
  currentAmount3DataBackup: number;
  currentPercent3DataBackup: number;
  currentPercentChecked3DataBackup: boolean;

  isBusy: boolean = true;
  saveDisabled: boolean = true;
  isBusyDoctorLocation: boolean = true;
  isEditing: boolean = false;

  constructor(
    private feeDiscountService: FeeDiscountsService,
    private snackBar: MatSnackBar,
    private doctorService: DoctorsService,
    public configurationService: ConfigurationService
    ) { }

  ngOnInit(): void {
    // doctors
    this.doctorService.getDoctors().subscribe((data) => {
      if (data.length > 0) {
        // order doctors by name
        data.sort((a, b) => {
          return (a.dataContact.FirstName > b.dataContact.FirstName ? 1 : -1);
        });

        this.doctorList = data;
        this.selectedDoctor = data[0];
        this.currentDoctorName = this.selectedDoctor.dataContact.FirstName + ' ' + this.selectedDoctor.dataContact.LastName;

        // load tdo table
        // this.refreshTableViewData(data);
      }

      // after drs are loaded, clients and locations
      this.feeDiscountService.getClients().subscribe(data2 => {
        this.clientList = data2;
        this.selectedClient = this.clientList[0];

        this.feeDiscountService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
          this.locationList = ldata;

          if (this.locationList.length > 0) {
            this.selectedLocation = this.locationList[0];
          }

          // load discounts if we have all necessary values
          if (this.selectedLocation && this.selectedClient && this.selectedDoctor) {
            this.loadDiscountsForDoctorLocations();
          }

          this.isBusy = false;
        });

      }, err => {
        console.log(err);
        this.isBusy = false;
      });
    });
  }

  setFeeDiscounts(doctor: DoctorDataModel) {
    // this gets called from table click event
    this.selectedDoctor = doctor;
    this.currentDoctorName = doctor.dataContact.FirstName + ' ' + doctor.dataContact.LastName;
    this.loadDiscountsForDoctorLocations();
  }

  onSave(event) {
    this.selectedDiscounts.forEach(a => {

      // record level 1
      if (a.DiscountName === 'Level1') {
        a.DiscountPCT = this.currentPercent1;
        a.DiscountAmount = this.currentAmount1;
        if (this.currentPercentChecked1) {
          a.enumFeeDiscountCalcTypeId = EnumFeeDiscountCalcTypeEnum.Percent;
        } else {
          a.enumFeeDiscountCalcTypeId = EnumFeeDiscountCalcTypeEnum.Money;
        }
      }

      // record level 2
      if (a.DiscountName === 'Level2') {
        a.DiscountPCT = this.currentPercent2;
        a.DiscountAmount = this.currentAmount2;
        if (this.currentPercentChecked2) {
          a.enumFeeDiscountCalcTypeId = EnumFeeDiscountCalcTypeEnum.Percent;
        } else {
          a.enumFeeDiscountCalcTypeId = EnumFeeDiscountCalcTypeEnum.Money;
        }
      }

      // record level 3
      if (a.DiscountName === 'Level3') {
        a.DiscountPCT = this.currentPercent3;
        a.DiscountAmount = this.currentAmount3;
        if (this.currentPercentChecked3) {
          a.enumFeeDiscountCalcTypeId = EnumFeeDiscountCalcTypeEnum.Percent;
        } else {
          a.enumFeeDiscountCalcTypeId = EnumFeeDiscountCalcTypeEnum.Money;
        }
      }
    });

    // save to db
    this.isBusyDoctorLocation = true;
    this.feeDiscountService.saveFeeDiscounts(this.selectedDiscounts).subscribe(data => {
      if (data) {
        this.configurationService.setClean();
        // save successful
        this.isBusyDoctorLocation = false;
        this.createMessage('Practice Details Saved', 'Success');
        this.saveDisabled = true;
        this.isEditing = false;
      }
    });
  }

  onCancel(event) {
    this.configurationService.setClean();
    this.saveDisabled = true;
    this.isEditing = false;

    this.currentAmount1 = this.currentAmount1DataBackup;
    this.currentAmount2 = this.currentAmount2DataBackup;
    this.currentAmount3 = this.currentAmount3DataBackup;

    this.currentPercent1 = this.currentPercent1DataBackup;
    this.currentPercent2 = this.currentPercent2DataBackup;
    this.currentPercent3 = this.currentPercent3DataBackup;

    this.currentPercentChecked1 = this.currentPercentChecked1DataBackup;
    this.currentPercentChecked2 = this.currentPercentChecked2DataBackup;
    this.currentPercentChecked3 = this.currentPercentChecked3DataBackup;
  }

  onEdit(event) {
    this.saveDisabled = false;
    this.isEditing = true;

    this.currentAmount1DataBackup = this.currentAmount1;
    this.currentAmount2DataBackup = this.currentAmount2;
    this.currentAmount3DataBackup = this.currentAmount3;

    this.currentPercent1DataBackup = this.currentPercent1;
    this.currentPercent2DataBackup = this.currentPercent2;
    this.currentPercent3DataBackup = this.currentPercent3;

    this.currentPercentChecked1DataBackup = this.currentPercentChecked1;
    this.currentPercentChecked2DataBackup = this.currentPercentChecked2;
    this.currentPercentChecked3DataBackup = this.currentPercentChecked3;
  }

  loadDiscountsForDoctorLocations() {
    // clients and locations
    this.feeDiscountService.getDiscountsForDoctorLocations(this.selectedDoctor.DoctorId).subscribe(data => {
      this.discountList = data;

      // initially load discounts based on dropdown default selections
      this.loadDiscountsForDoctorLocation();
    }, err => {
      console.log(err);
    });
  }

  loadDiscountsForDoctorLocation() {

    this.isBusyDoctorLocation = true;

    this.selectedDiscounts = this.discountList.filter(a => a.ProviderDoctorId === this.selectedDoctor.DoctorId && a.LOCID === this.selectedLocation.LOCID);

    this.currentAmount1 = this.returnDiscountDetailAmount('amount', '1');
    this.currentAmount2 = this.returnDiscountDetailAmount('amount', '2');
    this.currentAmount3 = this.returnDiscountDetailAmount('amount', '3');

    this.currentPercent1 = this.returnDiscountDetailAmount('percent', '1');
    this.currentPercent2 = this.returnDiscountDetailAmount('percent', '2');
    this.currentPercent3 = this.returnDiscountDetailAmount('percent', '3');

    this.currentPercentChecked1 = this.returnDiscountDetailChecked('percent', '1');
    this.currentPercentChecked2 = this.returnDiscountDetailChecked('percent', '2');
    this.currentPercentChecked3 = this.returnDiscountDetailChecked('percent', '3');

    this.isBusyDoctorLocation = false;
  }

  onChangeClient(event: MatSelectChange) {
    this.isBusy = true;

    this.feeDiscountService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.locationList = ldata;
      this.selectedLocation = null;

      if (this.locationList.length > 0) {
        this.selectedLocation = this.locationList[0];
        this.loadDiscountsForDoctorLocation();
      }
      this.isBusy = false;
    }, err => {
      console.log(err);
      this.isBusy = false;
    });
  }

  onChangeLoc(event) {
    // location changed
    this.selectedLocation = event.value;
    this.loadDiscountsForDoctorLocation();
  }

  returnDiscountDetailChecked(type: string, level: string) {
    let checked: boolean = false;
    if (type === 'amount') {
      const amount = this.selectedDiscounts.find(a => a.DiscountName === 'Level' + level && a.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Money);
      if (amount) {
        checked = true;
      }
    }
    else if (type === 'percent') {
      const percent = this.selectedDiscounts.find(a => a.DiscountName === 'Level' + level && a.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Percent);
      if (percent) {
        checked = true;
      }
    }
    return checked;
  }

  returnDiscountDetailAmount(type: string, level: string) {
    if (this.selectedDiscounts) {
      if (type === 'amount') {
        const amount = this.selectedDiscounts.find(a => a.DiscountName === 'Level' + level && a.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Money);
        if (amount) {
          return amount.DiscountAmount;
        }
      }
      else if (type === 'percent') {
        const percent = this.selectedDiscounts.find(a => a.DiscountName === 'Level' + level && a.enumFeeDiscountCalcTypeId === EnumFeeDiscountCalcTypeEnum.Percent);
        if (percent) {
          return percent.DiscountPCT;
        }
      }
      return 0;
    }
    else {
      return 0;
    }
  }

  radioChanged(event) {
    if (event.source.name === 'level1') {
      this.currentPercentChecked1 = false;
      if (event.value === '2') {
        this.currentPercentChecked1 = true;
      }
    }
    else if (event.source.name === 'level2') {
      this.currentPercentChecked2 = false;
      if (event.value === '2') {
        this.currentPercentChecked2 = true;
      }
    }
    else if (event.source.name === 'level3') {
      this.currentPercentChecked3 = false;
      if (event.value === '2') {
        this.currentPercentChecked3 = true;
      }
    }
    console.log(event);
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  onDoctorSelected(event: TdoTableSelectionEvent) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectDoctor(event.model);
          return;
        } else {
          this.selectedDoctor = event.model;
        }
      });
    } else {
      this.selectDoctor(event.model);
    }
  }

  selectDoctor(model: DoctorDataModel) {
    if (!this.isEditing) {
      this.isBusyDoctorLocation = true;
      this.setFeeDiscounts(model);
    }
  }

  deleteAdjustment() {
    // Coming soon
  }
}
